// ============================================================================
// RUSSIAN TRANSLATIONS - CHAPTER 5: РАННЯЯ ЦЕРКОВЬ
// ============================================================================
// Уровни 53-65 (13 уровней, 39 вопросов)

export const chapter5Translations = {
  name: "Ранняя Церковь",
  description: "Вы примете силу...",
  
  spiritualWisdom: {
    principle: "Святой Дух дает силу и мужество для свидетельства",
    scripture: "Но вы примете силу, когда сойдет на вас Дух Святой, и будете Мне свидетелями (Деяния 1:8)",
    application: "Церковь рождается в огне Духа и растет через смелое свидетельство"
  },
  
  levels: {
    53: {
      name: "Вознесение",
      challenge: "Будете Мне свидетелями... даже до края земли...",
      easy: {
        question: "Через сколько дней после воскресения Иисус вознесся на небо?",
        options: ["30 дней", "40 дней", "50 дней", "60 дней"],
        hint: "Библейское число приготовления",
        funFact: "☁️ 40 дней интенсивного обучения перед мировой миссией!"
      },
      medium: {
        question: "Какое обетование дал Иисус перед вознесением?",
        options: [
          "Что вернется немедленно",
          "Что пошлет Святого Духа с силой",
          "Что построит церковь",
          "Что накажет злых"
        ],
        hint: "Сила свыше",
        funFact: "⚡ Обетование Святого Духа - преображение испуганных учеников!"
      },
      hard: {
        question: "Что символизирует Вознесение в нашей духовной жизни?",
        options: [
          "Конец присутствия Иисуса",
          "Иисус царствует на небесах и ходатайствует за нас",
          "Окончательное прощание",
          "Символический миф"
        ],
        hint: "Речь идет о живом присутствии во славе",
        funFact: "👑 Иисус восседает одесную Бога, царствует и ходатайствует за нас!"
      }
    },
    
    54: {
      name: "Пятидесятница",
      challenge: "Исполнились все Духа Святого и начали говорить...",
      easy: {
        question: "Через сколько дней после Вознесения произошла Пятидесятница?",
        options: ["7 дней", "10 дней", "14 дней", "20 дней"],
        hint: "Около десяти дней",
        funFact: "🔟 10 дней пламенной молитвы готовят излияние Духа!"
      },
      medium: {
        question: "В какой форме явился Святой Дух?",
        options: [
          "Как мощный ветер",
          "Как разделяющиеся языки, как бы огненные",
          "Как голубь",
          "Как свет"
        ],
        hint: "Пламя, покоящееся на каждом ученике",
        funFact: "🔥 Огненные языки: Дух дает мужество и дар языков!"
      },
      hard: {
        question: "Что представляет Пятидесятница для вселенской Церкви?",
        options: [
          "Изолированное историческое событие",
          "Официальное рождение миссионерской Церкви",
          "Чудо любопытства",
          "Начало праздника"
        ],
        hint: "Речь идет о свидетельстве о рождении Церкви",
        funFact: "🎂 Пятидесятница = день рождения Церкви, начало мировой миссии!"
      }
    },

    55: {
      name: "Первая Проповедь Петра",
      challenge: "Что нам делать, братия? Покайтесь...",
      easy: {
        question: "Сколько человек крестились после проповеди Петра?",
        options: ["1000", "2000", "3000", "5000"],
        hint: "Три тысячи душ",
        funFact: "🌊 3000 крещений за один день - необыкновенное духовное пробуждение!"
      },
      medium: {
        question: "В чем Петр обвинил толпу?",
        options: [
          "В невежестве",
          "В распятии Иисуса, Мессии",
          "В недостатке веры",
          "В лицемерии"
        ],
        hint: "Высший грех против Сына Божьего",
        funFact: "⚔️ Петр, отрекшийся от Иисуса, теперь провозглашает Его божественность!"
      },
      hard: {
        question: "Как преображение Петра показывает действие Святого Духа?",
        options: [
          "Он стал более образованным",
          "Из боязливого и неустойчивого стал смелым и твердым в вере",
          "Он получил власть",
          "Он изменил характер"
        ],
        hint: "Речь идет об освящении Духом",
        funFact: "🗿 'Колеблющаяся трость' становится 'твердой скалой' - сила преображения!"
      }
    },

    56: {
      name: "Первая Община",
      challenge: "Они постоянно пребывали в учении апостолов и в общении...",
      easy: {
        question: "Как первые христиане делились имуществом?",
        options: [
          "Каждый сохранял свое",
          "Делились всем",
          "Только богатые давали",
          "По юридической обязанности"
        ],
        hint: "Добровольное разделение имущества",
        funFact: "🤝 Братская любовь столь интенсивна, что добровольно делились всем!"
      },
      medium: {
        question: "На что первые христиане тратили свое время?",
        options: [
          "Только на бизнес",
          "Учение, общение, преломление хлеба, молитва",
          "Только на работу",
          "Досуг"
        ],
        hint: "Четыре столпа общинной жизни",
        funFact: "⛪ Учение, общение, Евхаристия, молитва - основания Церкви!"
      },
      hard: {
        question: "Почему эта первая община была столь привлекательной?",
        options: [
          "Они были богаты",
          "Подлинная любовь и радость излучались от их единства",
          "Они обещали чудеса",
          "Они критиковали других"
        ],
        hint: "Речь идет о живом свидетельстве любви",
        funFact: "✨ 'Смотрите, как они любят друг друга!' - свидетельство убедительнее слов!"
      }
    },

    57: {
      name: "Исцеление Хромого",
      challenge: "Серебра и золота нет у меня, а что имею, то даю тебе...",
      easy: {
        question: "Как долго этот человек был хромым?",
        options: [
          "20 лет",
          "30 лет", 
          "От рождения",
          "10 лет"
        ],
        hint: "Инвалидность от рождения",
        funFact: "🚶 40 лет инвалидности мгновенно исцелены во имя Иисуса!"
      },
      medium: {
        question: "Во имя кого Петр исцелил хромого?",
        options: [
          "Во имя Бога",
          "Во имя Иисуса Христа Назорея",
          "В свое имя",
          "Во имя Авраама"
        ],
        hint: "Имя выше всякого имени",
        funFact: "✊ Имя Иисуса продолжает творить чудеса через апостолов!"
      },
      hard: {
        question: "Что символизирует это исцеление для Евангелия?",
        options: [
          "Простое медицинское чудо",
          "Полное спасение, которое приносит Иисус: духовное и физическое",
          "Сила апостолов",
          "Благотворительность для бедных"
        ],
        hint: "Речь идет о полном спасении человека",
        funFact: "🩺 Иисус исцеляет душу и тело - полное спасение человека!"
      }
    },

    58: {
      name: "Начало Гонений",
      challenge: "Должно повиноваться больше Богу, нежели человекам...",
      easy: {
        question: "Кто арестовал Петра и Иоанна после исцеления хромого?",
        options: [
          "Римляне",
          "Саддукеи и священники",
          "Народ",
          "Пилат"
        ],
        hint: "Иудейские религиозные власти",
        funFact: "⛓️ Первые религиозные гонения - Евангелие тревожит истеблишмент!"
      },
      medium: {
        question: "Что власти запретили апостолам?",
        options: [
          "Покидать Иерусалим",
          "Больше не учить во имя Иисуса",
          "Больше не творить чудес",
          "Больше не молиться"
        ],
        hint: "Запрет на проповедь",
        funFact: "🚫 Попытка заглушить истину - невозможно остановить Евангелие!"
      },
      hard: {
        question: "Как апостолы отреагировали на запрет?",
        options: [
          "Испугались и подчинились",
          "Заявили, что должно повиноваться больше Богу, нежели людям",
          "Вели переговоры",
          "Убежали"
        ],
        hint: "Речь идет о верности выше человеческого закона",
        funFact: "⚖️ Гражданское неповиновение ради послушания Богу - мужество убеждений!"
      }
    },

    59: {
      name: "Анания и Сапфира",
      challenge: "Ты солгал не человекам, а Богу...",
      easy: {
        question: "Какую ложь сказали Анания и Сапфира?",
        options: [
          "Они ничего не продавали",
          "Утаили часть, говоря, что отдают все",
          "Они были бедны",
          "Они не были женаты"
        ],
        hint: "Ложь о пожертвованной сумме",
        funFact: "💰 Утаить часть было допустимо, солгать о приношении - нет!"
      },
      medium: {
        question: "Что с ними случилось после лжи?",
        options: [
          "Были прощены",
          "Умерли мгновенно",
          "Были изгнаны",
          "Покаялись"
        ],
        hint: "Немедленное суровое наказание",
        funFact: "⚱️ Суровый суд для сохранения чистоты новорожденной Церкви!"
      },
      hard: {
        question: "Почему такое суровое наказание в начале Церкви?",
        options: [
          "Бог был жесток",
          "Чтобы установить святость, требуемую от общины",
          "Чтобы запугать",
          "Случайность"
        ],
        hint: "Речь идет о сохранении духовной целостности",
        funFact: "🔥 Высокие стандарты в начале для установления культуры святости!"
      }
    },

    60: {
      name: "Семь Диаконов",
      challenge: "Выберите из среды вашей семь человек изведанных...",
      easy: {
        question: "Сколько диаконов было избрано?",
        options: ["5", "6", "7", "12"],
        hint: "Число совершенства",
        funFact: "7️⃣ Семь диаконов для служения - божественная организация Церкви!"
      },
      medium: {
        question: "Какова была их главная роль?",
        options: [
          "Проповедовать Евангелие",
          "Служить за столами и помогать вдовам",
          "Крестить новообращенных",
          "Управлять финансами"
        ],
        hint: "Социальное и материальное служение",
        funFact: "🍽️ Служение за столами = первая христианская благотворительная организация!"
      },
      hard: {
        question: "Что эта организация открывает о христианском видении служения?",
        options: [
          "Материальная работа ниже",
          "Духовное и материальное служение одинаково священны",
          "Нужно отделять священное от мирского",
          "Только священники истинно служат"
        ],
        hint: "Речь идет о священности всякого служения любви",
        funFact: "✨ Служение за столами с тем же достоинством, что и проповедь - всякое служение священно!"
      }
    },

    61: {
      name: "Стефан, Первый Мученик",
      challenge: "Господи! не вмени им греха сего! Сказав сие, почил...",
      easy: {
        question: "Какова была роль Стефана в Церкви?",
        options: ["Апостол", "Диакон", "Священник", "Пророк"],
        hint: "Один из семи избранных для служения",
        funFact: "✨ Стефан: диакон становится могучим евангелистом и первым мучеником!"
      },
      medium: {
        question: "В чем Стефан обвинил иудейских лидеров?",
        options: [
          "В коррупции",
          "В постоянном противлении Святому Духу",
          "В лицемерии",
          "В жадности"
        ],
        hint: "Историческое сопротивление Богу",
        funFact: "📜 Стефан резюмирует историю: постоянный мятеж против Бога!"
      },
      hard: {
        question: "Как Стефан умер и что открывает его позиция?",
        options: [
          "В гневе на палачей",
          "Прощая, как Иисус на кресте",
          "В отчаянии",
          "Проклиная врагов"
        ],
        hint: "Речь идет о совершенном подражании Христу",
        funFact: "💝 Прощение палачам: Стефан в совершенстве воспроизводит позицию Иисуса!"
      }
    },

    62: {
      name: "Филипп и Эфиопский Евнух",
      challenge: "Как могу разуметь, если кто не наставит меня?",
      easy: {
        question: "Что евнух читал в колеснице?",
        options: [
          "Псалмы",
          "Пророка Исаию",
          "Бытие",
          "Притчи"
        ],
        hint: "Пророк о страданиях Мессии",
        funFact: "📖 Исаия 53 - совершенное пророчество об Иисусе, читаемое искренним искателем!"
      },
      medium: {
        question: "Как Филипп объяснил отрывок из Исаии?",
        options: [
          "Рассказал о древней истории",
          "Благовествовал ему Иисуса от этого Писания",
          "Провел урок богословия",
          "Критиковал толкование"
        ],
        hint: "Писание естественно ведет ко Христу",
        funFact: "✝️ Все Писание сходится в Иисусе - ключ понимания!"
      },
      hard: {
        question: "Что символизирует обращение эфиопского евнуха?",
        options: [
          "Изолированное обращение",
          "Универсальность Евангелия для всех рас и положений",
          "Превосходство определенной национальности",
          "Особый случай"
        ],
        hint: "Речь идет об открытости для народов",
        funFact: "🌍 Эфиоп, евнух, министр: Евангелие разрушает все барьеры!"
      }
    },

    63: {
      name: "Обращение Савла из Тарса",
      challenge: "Савл, Савл! что ты гонишь Меня?",
      easy: {
        question: "Что Савл делал до обращения?",
        options: [
          "Проповедовал Евангелие",
          "Преследовал христиан",
          "Был нейтрален",
          "Только учился"
        ],
        hint: "Яростный враг учеников",
        funFact: "⚔️ Савл дышал угрозами и убийством на учеников Иисуса!"
      },
      medium: {
        question: "На какой дороге Иисус явился Савлу?",
        options: [
          "Дорога в Иерусалим",
          "Дорога в Дамаск",
          "Дорога в Газу",
          "Дорога в Антиохию"
        ],
        hint: "Город в Сирии",
        funFact: "🛤️ Дорога в Дамаск = самое знаменитое место преображения в истории!"
      },
      hard: {
        question: "Как это обращение демонстрирует благодать Божью?",
        options: [
          "Бог обращает только хороших людей",
          "Благодать может превратить худшего врага в величайшего апостола",
          "Обращение было заслужено",
          "Савл уже был близок к Богу"
        ],
        hint: "Речь идет о преобразующей силе благодати",
        funFact: "⚡ От величайшего гонителя к величайшему миссионеру - чудо благодати!"
      }
    },

    64: {
      name: "Петр и Корнилий",
      challenge: "Истинно познаю, что Бог нелицеприятен...",
      easy: {
        question: "Какова была профессия Корнилия?",
        options: [
          "Торговец",
          "Римский сотник",
          "Священник",
          "Книжник"
        ],
        hint: "Офицер римской армии",
        funFact: "🎖️ Первый официально обращенный язычник - открытие для неиудеев!"
      },
      medium: {
        question: "Какое видение было у Петра перед встречей с Корнилием?",
        options: [
          "Говорящий ангел",
          "Полотно с чистыми и нечистыми животными",
          "Являющийся Иисус",
          "Разрушенный храм"
        ],
        hint: "Видение о чистоте и нечистоте",
        funFact: "🕊️ Полотно с животными: Бог отменяет различия в пище и расах!"
      },
      hard: {
        question: "Какой революционный принцип установило это обращение?",
        options: [
          "Римляне превосходят",
          "Бог нелицеприятен - всеобщее спасение",
          "Нужно отказаться от традиций",
          "Обрезание бесполезно"
        ],
        hint: "Речь идет о всеобщности спасения",
        funFact: "🌍 Духовная революция: Евангелие для всех народов без исключения!"
      }
    },

    65: {
      name: "Церковь в Антиохии",
      challenge: "В Антиохии ученики в первый раз стали называться христианами...",
      easy: {
        question: "Как впервые назвали учеников в Антиохии?",
        options: ["Ученики", "Христиане", "Верующие", "Святые"],
        hint: "Имя, которое у нас есть и сегодня",
        funFact: "✝️ 'Христиане' = 'малые Христы' - почетное имя, данное язычниками!"
      },
      medium: {
        question: "Кто пришел учить в Антиохию вместе с Варнавой?",
        options: [
          "Петр",
          "Павел (Савл)",
          "Иаков",
          "Иоанн"
        ],
        hint: "Бывший гонитель, ставший апостолом",
        funFact: "👥 Варнава ищет Павла в Тарсе - начало служения Павла!"
      },
      hard: {
        question: "Почему Антиохия стала столь важной в христианской истории?",
        options: [
          "Она была богата",
          "Первый миссионерский центр для язычников",
          "Хорошее расположение",
          "Хорошие лидеры"
        ],
        hint: "Речь идет о миссионерской экспансии",
        funFact: "🚢 Антиохия: порт отправления всех миссионерских путешествий Павла в Европу!"
      }
    }
  }
};

export default chapter5Translations;
